import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
@Component({
  selector: 'app-check-order',
  templateUrl: './check-order.component.html',
  styleUrls: ['./check-order.component.scss']
})
export class CheckOrderComponent implements OnInit {
  receivingNumber: string;

  constructor(private _dialogService: TdDialogService,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

  goBack(): void {
    this.location.back();
  }

  check() {

  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/shipping/check-order/check-order.component.ts